import { combineReducers } from 'redux';

import emailContent from './EmailContent';
import Emails from './Emails';
import emailSearch from './EmailSearch';
import selectedEmail from './SelectedEmail';
import visibilityFilter from './VisibilityFilter';

const EmailReducer = combineReducers({
  Emails,
  visibilityFilter,
  selectedEmail,
  emailSearch,
  emailContent,
});

export default EmailReducer;
